import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg"
import "./row-action.scss"

interface DuplicateRowActionProps {
    row;
    duplicateClickHandler?: (row) => void;
    cameraGroupId?: number
}

export const DuplicateRowAction = ({ row, duplicateClickHandler, cameraGroupId }: DuplicateRowActionProps) => {

    const id = cameraGroupId ?? row.original.id 

    return (
        <button
            id={"xsd__e2e-table-actions-duplicate-row-" + row.index}
            className="row-action"
            type="button"
            onClick={() => {
                if (duplicateClickHandler) {
                    duplicateClickHandler(id);
                } else {
                    console.error('duplicateClickHandler is not defined');
                }
            }}
            title="Duplicate"
        >
            <svg className="msds-icon">
                <use href={`${spritemap}#copy`} />
            </svg>
        </button>
    );
};
